export class OneDriveConstants {
    // The name of the root folder in One Drive after 'My Files'
    static ROOT_FOLDER = 'Cases'

    // The chunk size to use when uploading / downloading files
    static CHUNK_SIZE = 4 * 1024 * 1024
}
